<i18n>
{
	"en": {
		"newDriver": "New driver"
	},
	"no": {
		"newDriver": "Ny sjåfør"
	}
}
</i18n>
<template>
	<div>
		<t-button
			appearance="primary"
			icon-before="plus"
			:value="$t('newDriver')"
			@click="isNewDriverDialogShown = true"
		/>
		<NewDriverDialog :isShown="isNewDriverDialogShown" @ok="onOk" @close="onClose"/>
	</div>
</template>

<script>
import NewDriverDialog from './NewDriverDialog';
export default {
	name: 'NewDriverButton',
	components: {
		NewDriverDialog
	},
	data() {
		return {
			isNewDriverDialogShown: false,
		};
	},
	methods: {
		onOk(newUser) {
			this.isNewDriverDialogShown = false;
			this.$emit('ok', newUser);
		},
		onClose() {
			this.isNewDriverDialogShown = false;
			this.$emit('close');
		}
	}
};
</script>

<style>

</style>